// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_mQ8","cls2":"ImpactHubModal-cls2_JTi ImpactHubModal-cls1_mQ8"};